import {
  REFUND,
  REFUND_SUCCESS,
  REFUND_FAILURE,
} from "../actionTypes";

export const refund = (payload) => ({
  type: REFUND,
  payload,
});

export const refundSuccess = (payload) => ({
  type: REFUND_SUCCESS,
  payload,
});

export const refundFailure = () => ({
  type: REFUND_FAILURE,
});
